import { action } from 'easy-peasy';
import { IActionSetResource } from '../types';

const setResource: IActionSetResource = action((state, resource) => {
  state.current = resource;
});

export default setResource;
